// unauthorized.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthStore } from '@store/auth.facade';

export const unauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
    const router = inject(Router);
    const authStore = inject(AuthStore);

    return next(req).pipe(
        catchError((err) => {
            if (err.status === 401) {
                authStore.clearAuth();
                router.navigate(['/login']);
            }
            return throwError(() => err);
        })
    );
};